#import "./ContractFields.graphql"

mutation UpdateContract(
  $id: ID!
  $attributes: ContractAttributesInput!
  $status: ContractStatusEnum
) {
  updateContract(
    input: { id: $id, attributes: $attributes, status: $status }
  ) {
    contract {
      ...ContractFields
    }
  }
}
